<footer id="footer" class="footer navbar navbar-expand-lg fixed-bottom">
  <div class="container">
    <div class="navbar-collapse">
      @for (s of sections; track s.id) {
        <div class="navbar-nav {{$index === 0 ? '' : 'ml-auto'}}">
          <div class="nav-item">
            <a class="nav-link" title="{{s.title}}" href="#{{s.id}}">
              <span>{{s.title}}</span>
            </a>
          </div>
        </div>
      }
    </div>
  </div>
</footer>
